import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { ApiConfig } from 'src/app/utility/ApiConfig';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
declare function setDatatableSearch(): any;

@Component({
  selector: 'app-edit-coa-subtype',
  templateUrl: './edit-coa-subtype.component.html',
  styleUrls: ['./edit-coa-subtype.component.sass']
})
export class EditCoaSubtypeComponent implements OnInit {

  constructor(
    private ApiConfig: ApiConfig,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
  ) { }

  subtipeCoaForm = new FormGroup({
    coaType   : new FormControl('', [Validators.required]),
    coaCode   : new FormControl('', [Validators.required]),
    coaSubtype: new FormControl('', [Validators.required]),
  });

  dtOptions: DataTables.Settings = {};
  httpOptions: any = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': this.ApiConfig.USER_DATA.token })
  };
  responseApi: any;
  tempCoaType: any;
  idParam: any;

  ngOnInit(): void {
    this.getCoaType();
    if (this.route.snapshot.params.id) {
      this.idParam = this.route.snapshot.params.id;
      this.getData(this.idParam);
    }
  }

  getData(idParam){
    this.http.get(this.ApiConfig.API_URL + "/coa-subtype/" + idParam, this.httpOptions).subscribe(
      res => {
        this.responseApi = res;
        if(this.responseApi.status == "200"){
          var data = this.responseApi.data;
          this.subtipeCoaForm.patchValue({
            coaType     : data.coa_type,
            coaCode     : data.code,
            coaSubtype  : data.coa_subtype_name
          })
        }
      }, 
      err => {
        console.log(err);
      }
    );
  }

  editSubtipe(){
    this.http.put(this.ApiConfig.API_URL + "/coa-subtype/" + this.idParam, this.subtipeCoaForm.value, this.httpOptions).subscribe(
      res => {
          this.responseApi = res;
          if (this.responseApi.status == "200") {
            Swal.fire("Selamat", "Anda berhasil mengedit Subtipe COA", "success").then(() => {
              this.router.navigate(['/admin/coa-subtype']);
            });
          } else {
            Swal.fire("Maaf", "Anda gagal mengedit Subtipe COA", "error")
          }
      },
      err => {
        Swal.fire("Maaf", "Anda gagal mengedit Subtipe COA", "error")
      }
    );
  }

  getCoaType(){
    this.http.get(this.ApiConfig.API_URL + "/coa-type", this.httpOptions).subscribe(
      res => {
        this.responseApi = res;
        if(this.responseApi.status == "200"){
          this.tempCoaType = this.responseApi.data.map(coa => ({
            "id"    : coa.code,
            "text"  : coa.code + ' - ' + coa.coa_type_name,
            "additional"  : coa
          }));
          // console.log(this.tempProvince);
        }
      }, 
      err => {
        console.log(err);
      }
    );
  };

  onChangeCoaSubtype(event: any){
    this.subtipeCoaForm.patchValue({
      coaType : event
    });
  }

}
